import {
  SpecialTabs,
  Tab,
  TabDescriptor,
  TabIDToType,
  tabIDToType,
} from "@store/minersSelect/actionTypes";
import React, { useCallback, useMemo } from "react";
import connected from "@assets/redesign/icons/connected.svg";
import { useIntl } from "react-intl";
import { useAuth } from "@utils/hooks/useAuth";


// interface TabItem {
//   id: number;
//   name?: string;
//   title?: string;
//   adminOnly?: boolean;
// }

// interface SpecialTabsItem extends TabItem {
//   adminOnly?: boolean;
// }

interface Props {
  className?: string;
  value?: number;
  onChange?: (id: number, name: string) => void;
  tabsTotals: Record<string, number>;
}


const TabListItem: React.FC<{
  item: TabDescriptor;
  total: number;
  onClick: (id: number, name: string) => void;
}> = React.memo(({ item, total, onClick }) => {

  const { formatMessage } = useIntl();

  const isNegativeId = item.id < 0;
  const displayName = isNegativeId && item.name
    ? formatMessage({ id: item.name })
    : item.name || '';

  const title = isNegativeId && item.title
    ? formatMessage({ id: item.title })
    : item.title || displayName;

  const handleClick = useCallback(() => {
    const nameForCallback = item.name
      ? isNegativeId
        ? formatMessage({ id: item.name })
        : item.name
      : '';
    onClick(item.id, nameForCallback);
  }, [item.id, item.name, isNegativeId, formatMessage, onClick]);

  return (
    <li title={title} onClick={handleClick}>
      <img src={connected} alt="" /> {/* connected должен быть импортирован или передан */}
      <span>
        {displayName} ({total})
      </span>
    </li>
  );
});

// Основной компонент или часть рендера
const TabsList: React.FC<Props & {
  SpecialTabs: TabDescriptor[];
  tabs: TabDescriptor[];
}> = ({ SpecialTabs, tabs, value, className, onChange, tabsTotals }) => {

  const auth = useAuth();

  // Фильтрация и подготовка данных для отображения
  const visibleTabs = useMemo(() => {
    // Общая функция проверки видимости таба
    const isVisible = (item: TabDescriptor): boolean => {
      if (value === item.id) return false;
      const type = tabIDToType(item.id);
      if (!type) return false;
      const total = tabsTotals[type];
      if (!total) return false;
      // Для SpecialTabs учитываем adminOnly
      if ('adminOnly' in item && item.adminOnly && !auth.isAdmin) return false;
      return true;
    };

    // Создаём копии с добавлением total для удобства
    const mapToRenderItem = (item: TabDescriptor) => ({
      ...item,
      total: tabsTotals[tabIDToType(item.id)!],
    });

    const specialItems = SpecialTabs.filter(isVisible).map(mapToRenderItem);
    const normalItems = tabs.filter(isVisible).map(mapToRenderItem);
    return [...specialItems, ...normalItems];
  }, [SpecialTabs, tabs, value, auth.isAdmin, tabsTotals]);

  // Обработчик клика
  const handleTabClick = useCallback((id: number, name: string) => {
    onChange?.(id, name);
  }, [onChange]);

  return (
    <ul className={className}>
      {visibleTabs.map((item) => (
        <TabListItem
          key={item.id} // Используем уникальный id вместо индекса
          item={item}
          total={item.total}
          onClick={handleTabClick}
        />
      ))}
    </ul>
  );
};

export default TabsList;